import { env } from "../_utils/env";
import { classNames } from "../_utils/classNames";
import { cssGet } from "../_utils/css";

export function shouldBeConsumedByChild(
    element: HTMLElement,
    target,
    deltaX: number,
    deltaY: number
) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector("select:focus")) {
        return true;
    }

    if (!element.contains(target)) {
        return false;
    }

    let cursor = target;

    while (cursor && cursor !== element) {
        if (cursor.classList.contains(classNames.element.consuming)) {
            return true;
        }

        const style = cssGet(cursor);

        // if deltaY && vertical scrollable
        if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
            const maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
            if (maxScrollTop > 0) {
                if (
                    (cursor.scrollTop > 0 && deltaY < 0) ||
                    (cursor.scrollTop < maxScrollTop && deltaY > 0)
                ) {
                    return true;
                }
            }
        }
        // if deltaX && horizontal scrollable
        if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
            const maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
            if (maxScrollLeft > 0) {
                if (
                    (cursor.scrollLeft > 0 && deltaX < 0) ||
                    (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
                ) {
                    return true;
                }
            }
        }

        cursor = cursor.parentNode;
    }

    return false;
}
